$(document).ready(function(){

    $('.show-more').click(function(){
    
      var parent = $(this).parents('.more-holder');

        $(this).addClass('active');
        parent.find('.less, .show-more').hide();
        parent.find('.more, .show-less').show();
    })
    
    $('.show-less').click(function(){
    
      var parent = $(this).parents('.more-holder');

        $(this).addClass('active');
        parent.find('.less, .show-more').show();
        parent.find('.more, .show-less').hide();
    })
    
})